<template>
  <form
    class="login-form basic-form"
    @submit.prevent="saveData()"
    autocomplete="off"
    novalidate
  >
    <div class="header">{{ $t("login_to_client_zone") }}</div>
    <p class="description">
      {{ $t("login_to_client_zone_new_device_information") }}
    </p>
    <vue-form-generator
      ref="mainForm"
      :schema="schema"
      :model="model"
      :options="formOptions"
    />
    <div class="text-right button-verification">
      <button
        type="button"
        class="btn btn-sm pb-0 pl-0 pr-0 btn-link btn-small-link"
        @click="sendAgain()"
      >
        {{ $t("resend_sms_code") }}
      </button>
    </div>
    <div class="text-right mt-4 pt-1">
      <button type="submit" class="btn btn-sm pl-4 pr-4 btn-primary">
        {{ $t("log_in") }}
      </button>
    </div>
  </form>
</template>

<script>
import { validateForm } from "../../../utils";

export default {
  name: "Verification",
  mounted() {
    if (!this.$store.state.account.profile) {
      this.$router.push({ name: "login" });
    } else {
      this.$store.dispatch("account/sendPinCodeAgain");
      this.$refs.mainForm.$el.getElementsByTagName("input")[0].focus();
    }
  },
  computed: {
    accountingDay() {
      return new Date();
    }
  },
  methods: {
    saveData() {
      if (validateForm(this.$refs.mainForm)) {
        this.$store.dispatch("account/activate", this.model).then(() => {
          this.$router.push({ name: "dashboard" });
        });
      }
    },
    sendAgain() {
      this.$store.dispatch("account/sendPinCodeAgain");
    }
  },
  data() {
    return {
      model: {
        code: "",
        remember: true
      },
      schema: {
        fields: [
          {
            type: "customCheckbox",
            name: this.$t("remember_device"),
            placeholder: "placeholder",
            model: "remember"
          },
          {
            type: "input",
            inputType: "password",
            placeholder: this.$t("sms_code_placeholder"),
            model: "code",
            required: true,
            validator: "string"
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: false,
        validateAsync: false
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.button-verification {
  margin-top: -20px;
}
</style>
